import { Box, Typography } from "@mui/material";

const FONT = "Lato, sans-serif";

const EMPTY_STATE_CARD_SX = {
  boxSizing: "border-box",
  width: "100%",
  bgcolor: "#FFFFFF",
  border: "1px solid #E2E8F0",
  borderRadius: "12px",
  p: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 280,
  flex: 1,
};

const EMPTY_STATE_INNER_SX = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  width: "100%",
  flex: 1,
};

const EMPTY_STATE_ICON_WRAP_SX = {
  width: 64,
  height: 64,
  borderRadius: "100px",
  bgcolor: "#F0F6FF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const EMPTY_STATE_TEXT_GROUP_SX = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "6px",
  px: 3,
  maxWidth: 560,
  width: "100%",
  boxSizing: "border-box",
};

const EMPTY_STATE_TITLE_SX = {
  fontFamily: FONT,
  fontSize: 20,
  fontWeight: 700,
  lineHeight: "28px",
  color: "#383838",
  textAlign: "center",
  m: 0,
};

const EMPTY_STATE_DESCRIPTION_SX = {
  fontFamily: FONT,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "22px",
  color: "#555555",
  textAlign: "center",
  m: 0,
};

/**
 * Centered empty state inside a card shell (icon + title + description).
 */
/** When true, `icon` is a full 64×64 asset (e.g. SVG with its own circle) — skip the default icon shell. */
export default function EmptyState({
  icon,
  title,
  description,
  headingLevel = "h3",
  iconIncludesContainer = false,
  sx,
  innerSx,
}) {
  return (
    <Box sx={{ ...EMPTY_STATE_CARD_SX, ...sx }}>
      <Box sx={{ ...EMPTY_STATE_INNER_SX, ...innerSx }}>
        <Box
          aria-hidden
          sx={
            iconIncludesContainer
              ? { flexShrink: 0, display: "flex", lineHeight: 0 }
              : EMPTY_STATE_ICON_WRAP_SX
          }
        >
          {icon}
        </Box>
        <Box sx={EMPTY_STATE_TEXT_GROUP_SX}>
          <Typography component={headingLevel} sx={EMPTY_STATE_TITLE_SX}>
            {title}
          </Typography>
          <Typography component="p" sx={EMPTY_STATE_DESCRIPTION_SX}>
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
